import style from './Report.module.scss';
import { FaFilePdf } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import ExportReport from '../Modals/ExportReport/ExportReport';

const ReportTypeStructure = ({ report, header, content, isStandalone }) => {
    const [ showModal, setShowModal ] = useState(false);

    return (
        <div className={isStandalone ? style.reportStandaloneContent : style.reportContent}>
            <ExportReport report={report} show={showModal} onClose={(e) => {
                setShowModal(false);
            }} />
            <div className={ style.reportContainer }>
                <div className={ style.header }>
                    <div>
                        { header }
                    </div>
                    <div>
                        <div>
                            <button className={ style.pdfButton } onClick={ (e) => {
                                setShowModal(true);
                            } }><FaFilePdf /> Download PDF</button>
                        </div>
                    </div>
                </div>
                <div className={ style.content }>
                    { content }
                </div>
            </div>
        </div>
    )
}

export default ReportTypeStructure;